import { NavLink } from "react-router-dom";

export default function HowItWorks() {
  const steps = [
    {
      number: "1",
      title: "Choose Your Style & Create Story",
      description: "Two personalization options available",
      icon: "✨",
      detail: "Choose your story style and add story details. We craft your unique tale in minutes.",
      hasSubSteps: true,
      subSteps: [
        {
          icon: "📸",
          title: "Photo Stories",
          description: "Upload your family photos - we'll create characters that look like your loved ones"
        },
        {
          icon: "👤", 
          title: "Avatar Stories",
          description:  "Select appearance traits (skin tone, hair color, etc.) - we provide matching pre-made characters"
        }
      ]
    },
    {
      number: "2",
      title: "Read & Enjoy Online",
      description: "Download PDF or read in browser",
      icon: "🖥️",
      detail: "Enjoy your story immediately"
    },
    {
      number: "3",
      title: "Love it? Order a Beautiful Printed Book",
      description: "Optional premium keepsake",
      icon: "📚",
      detail: "Transform your digital story into a gorgeous physical book to treasure forever"
    }
  ];

  return (
<div className="bg-indigo-50 pt-24 pb-16">      
  <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            How MyTaleMaker Works
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Create, read, and keep in 3 steps
          </p>
        </div>
        
        <div className="mx-auto mt-10 max-w-5xl">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            {steps.map((step, index) => (
              <div key={step.number} className="relative text-center">
                {/* Connector line for desktop */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-12 left-1/2 w-full h-0.5 bg-indigo-200 z-0"
                    style={{ transform: 'translateX(50%)' }} />
                )}
                
                <div className="relative z-10 bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow duration-300">
                  {/* Step number circle */}
                  <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-indigo-600 text-2xl font-bold text-white">
                    {step.number}
                  </div>
                  
                  {/* Icon */}
                  <div className="text-3xl mb-3">{step.icon}</div>
                  
                  {/* Title */}
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {step.title}
                  </h3>
                  
                  {/* Description */}
                  <p className="text-sm font-medium text-indigo-600 mb-3">
                    {step.description}
                  </p>
                  
                  {/* Sub-steps for Step 1 */}
                  {step.hasSubSteps && (
                    <div className="mb-4 space-y-3">
                      {step.subSteps.map((subStep, subIndex) => (
                        <div key={subIndex} className="bg-gray-50 p-3 rounded-lg border border-gray-100">
                          <div className="flex items-center justify-center mb-2">
                            <span className="text-lg mr-2">{subStep.icon}</span>
                            <span className="text-sm font-medium text-gray-900">{subStep.title}</span>
                          </div>
                          <p className="text-xs text-gray-600">{subStep.description}</p>
                        </div>
                      ))}
                    </div>
                  )}
                  
                  {/* Detail */}
                  <p className="text-sm text-gray-600">
                    {step.detail}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}